import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import ConversationItemCard from 'components/lib/customer_conversation_card/conversation_item_card';
import CustomerCard from 'components/lib/customer_conversation_card/customer_card';

export default function CustomerConversationItemCard(props) {
  const classNames = classnames('customerConversationItemCard', {
    'customerConversationItemCard-selected': props.isSelected,
  });
  const { profile, onClick, conversationItem } = props;
  return (
    <div className={classNames} onClick={onClick}>
      <CustomerCard {...profile} />
      <ConversationItemCard {...conversationItem} />
    </div>
  );
}

CustomerConversationItemCard.propTypes = Object.assign({
  profile: PropTypes.shape(CustomerCard.propTypes),
  conversationItem: PropTypes.object,
  onClick: PropTypes.func,
});



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/customer_conversation_card/customer_conversation_item_card.jsx